"use client";

import { Center } from "@cloudspire/shared/components/ui/center";
import { Spinner } from "@cloudspire/shared/components/ui/spinner";

export function DataHandlerSpinner() {
  return (
    <Center>
      <Spinner size="lg" />
    </Center>
  );
}
